export default {"src":"/uk/_next/static/media/plaid.f65959e7.svg","height":48,"width":126,"blurWidth":0,"blurHeight":0};